<template>
  <div>
    SHORTCUT PAGE
    <hr>
    <b-form-group :class="{'error-input' : $v.data_shortcut.title.$error}">
      <label> Title </label>
      <j-input
        v-model="$v.data_shortcut.title.$model"
        :max-length="255"
        placeholder="Title"/>
    </b-form-group>

    <div
      :class="{'border-danger' : $v.data_shortcut.view_style.$error}"
      class="widget-box-configuration"
    >
      <div class="widget-box-configuration_title">View style options</div>
      <div class="widget-box-configuration_desc">Options for style list of shortcut</div>

      <div class="d-flex">
        <div
          :class="{ 'item-style-options-active': data_shortcut.view_style === 'list' }"
          class="widget-box-configuration_item-style-options"
          @click="data_shortcut.view_style = 'list'"
        >
          <img
            :src="iconViewStyleList"
            width="10"
            height="10"
          >
          List
        </div>
        <div
          :class="{ 'item-style-options-active': data_shortcut.view_style === 'grid' }"
          class="widget-box-configuration_item-style-options"
          @click="data_shortcut.view_style = 'grid'"
        >
          <img
            :src="iconViewStyleGrid"
            width="10"
            height="10"
          >
          Grid
        </div>
      </div>
    </div>

    <div
      :class="{'border-danger' : $v.data_shortcut.shortcut.$error}"
      class="widget-box-configuration"
    >
      <div class="widget-box-configuration_title">Shortcuts</div>
      <div class="widget-box-configuration_desc">List of shortcut</div>

      <div
        :class="{ 'flex-column': data_shortcut.view_style === 'list' }"
        class="d-flex flex-wrap"
      >
        <div
          v-for="(val, index) in data_shortcut.shortcut"
          :key="index"
          :class="`${data_shortcut.view_style === 'list' ?
            'list-of-shortcut' :
          'grid-of-shortcut'}`"
          @click="openModalShortcut(val, index)"
        >
          <img :src="val.icon">
          <span>{{ val.title }}</span>
        </div>

        <div
          v-if="data_shortcut.view_style === 'grid'"
          class="grid-of-shortcut"
          @click="openModalShortcut(null, 0)"
        >
          <img
            :src="require('@/assets/icon/shortcut-page/add.svg')"
            class="btn-add-shortcut"
          >
          <div class="label-add-shortcut">Add shortcut</div>
        </div>
      </div>

      <div
        v-if="data_shortcut.view_style === 'list'"
        class="widget-box-configuration_add-shorcut"
        @click="openModalShortcut(null, 0)"
      >
        <img
          :src="require('@/assets/icon/shortcut-page/add.svg')"
          width="11"
          height="11"
        >
        Add shortcut
      </div>
    </div>
    <b-row>
      <b-col>
        <div class="float-to-right">
          <b-button
            class="btn gray m__r--5"
            @click="closeShortcut">
            Close
          </b-button>
          <b-button
            class="btn blue"
            @click="saveShortcut">
            Save
          </b-button>
        </div>
      </b-col>
    </b-row>

    <!-- Modal Shortcut -->
    <b-modal
      ref="modalShorcut"
      :hide-header="true"
      :hide-footer="true"
      class="modal-shortcut-page-wrap"
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="modal-shortcut-page">
        <div class="modal-shortcut-page__header">
          <div class="modal-shortcut-page__header__title">
            <img
              src="@/assets/icon/shortcut-page/add-shortcut.svg"
              width="33"
              height="33"
            >
            <div class="title">{{ mode_form === 'create' ? 'Add' : 'Edit' }} Shortcut</div>
          </div>
          <p
            class="modal-shortcut-page__header__icon"
            @click="$emit('close')"
          >
            &times;
          </p>
        </div>

        <div class="modal-shortcut-page__content">
          <div class="widget-box-configuration m__b--10">
            <div class="widget-box-configuration_title">Icon</div>
            <div class="widget-box-configuration_desc">
              Image that represents the shortcut button
            </div>
            <div class="d-flex">
              <div
                :class="{'error-icon' : $v.item_shortcut.icon_url.$error}"
                class="preview-icon">
                <img
                  v-if="item_shortcut.icon_url"
                  :src="item_shortcut.icon_url"
                >
                <input
                  ref="iconUpload"
                  type="file"
                  class="upload-photo"
                  @change="handleIconUpload($event)"
                >
              </div>
              <div>
                <div
                  v-if="item_shortcut.icon_url"
                  class="widget-box-configuration_title"
                >
                  {{ item_shortcut.icon_url.split('/').pop() }}
                </div>
                <div
                  v-else
                  class="widget-box-configuration_title"
                >
                  None
                </div>
                <div
                  class="upload-btn"
                  @click="$refs.iconUpload.click()"
                >
                  Change
                </div>
              </div>
            </div>
          </div>

          <b-form-group
            :class="{'error-input' : $v.item_shortcut.title.$error}"
            class="m__b--10"
          >
            <label> Title </label>
            <j-input
              v-model="$v.item_shortcut.title.$model"
              :max-length="255"
              :error-required="$v.item_shortcut.title.$error"
              placeholder="Title"/>
          </b-form-group>
          <b-form-group
            :class="{'error-input' : $v.item_shortcut.application.$error}"
            class="m__b--10"
          >
            <label> Application </label>
            <j-single-select
              v-model="$v.item_shortcut.application.$model"
              :options="applications_list"
              :error-required="$v.item_shortcut.application.$error"
              label="name"
              value-format="object"
              placeholder="Choose Application"
              @getData="getApplicationPages"
            />
          </b-form-group>
          <b-form-group
            :class="{'error-input' : $v.item_shortcut.page.$error}"
            class="m__b--10"
          >
            <label> Page </label>
            <j-single-select
              v-model="$v.item_shortcut.page.$model"
              :options="list_page"
              :error-required="$v.item_shortcut.page.$error"
              label="name"
              value-format="object"
              placeholder="Choose Page"
            />
          </b-form-group>
        </div>

        <div class="modal-shortcut-page__footer">
          <div>
            <button
              v-if="mode_form === 'update'"
              class="button-red"
              @click="removeItemShortcut"
            >
              Delete
            </button>
          </div>
          <div class="d-flex">
            <button
              class="button-border m__r--10"
              @click="closeModalShortcut"
            >
              Close
            </button>
            <button
              class="button-blue"
              @click="saveItemShortcut"
            >
              {{ mode_form === 'create' ? 'Save' : 'Update' }}
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions, mapState } from 'vuex';
// Mixins
import jMixUploadFile from '@/mixins/jMixUploadFile';

export default {
  mixins: [jMixUploadFile],
  props: {
    dataMaster: {
      type: Object,
      default: () => {},
    },
    modeCreate: {
      type: Boolean,
      default: false,
    },
    modeEdit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    data_shortcut: {
      title: { required },
      view_style: { required },
      shortcut: {},
    },
    item_shortcut: {
      icon_url: { required },
      title: { required },
      application: { required },
      page: { required },
    },
  },
  data() {
    return {
      data_shortcut: {
        title: '',
        view_style: 'list',
        shortcut: [],
      },
      item_shortcut: {
        icon_url: '',
        title: '',
        application: null,
        page: null,
      },
      list_page: [],
      index_selected: 0,
      mode_form: 'create',
    };
  },
  computed: {
    ...mapState('jStoreSetting', ['applications_list']),

    generateDataShortcut() {
      const data = {
        info: JSON.stringify({
          name: this.data_shortcut.title,
          view_style: this.data_shortcut.view_style,
          shortcut: this.data_shortcut.shortcut,
        }),
        name: this.data_shortcut.title,
        widget_master_id: this.dataMaster.id,

        type: 1,
        position: this.dataMaster.position,
      };

      if (this.modeEdit) data.order = this.dataEdit.order;
      return data;
    },

    iconViewStyleList() {
      if (this.data_shortcut.view_style === 'list') {
        // eslint-disable-next-line
        return require('@/assets/icon/shortcut-page/list-blue.svg');
      }
      // eslint-disable-next-line
      return require('@/assets/icon/shortcut-page/list.svg');
    },

    iconViewStyleGrid() {
      if (this.data_shortcut.view_style === 'grid') {
        // eslint-disable-next-line
        return require('@/assets/icon/shortcut-page/grid-blue.svg');
      }
      // eslint-disable-next-line
      return require('@/assets/icon/shortcut-page/grid.svg');
    },
  },
  created() {
    this.getApplicationList();
  },
  mounted() {
    if (this.modeEdit) {
      this.data_shortcut.title = JSON.parse(this.dataEdit.info).name;
      this.data_shortcut.view_style = JSON.parse(this.dataEdit.info).view_style;
      this.data_shortcut.shortcut = JSON.parse(this.dataEdit.info).shortcut;
    }
  },
  methods: {
    ...mapActions('jStoreApplication', ['saveWidget', 'updateWidget']),
    ...mapActions('jStoreSetting', ['actionGetApplicationsList', 'actionGetPagesList']),

    getApplicationList() {
      const parameter = {
        page: 1,
        limit: 1000,
        column: 'updated_at',
        sort: 'desc',
      };
      this.actionGetApplicationsList({ params: parameter });
    },

    getApplicationPages() {
      const applicationId = this.item_shortcut.application.id;
      const param = {
        params: {
          page: 1,
          limit: 0,
          column: 'id',
          sort: 'asc',
          query: '',
          query_type: '',
        },
      };
      this.actionGetPagesList({ applicationId, param }).then((res) => {
        if (!res.error) this.list_page = res.data.filter(f => f.type === 'visible');
      });
    },

    openModalShortcut(data, index) {
      if (data) {
        this.index_selected = index;
        this.item_shortcut.icon_url = data.icon;
        this.item_shortcut.title = data.title;
        this.item_shortcut.application = {
          id: data.application_id,
          name: data.application_name,
        };
        this.item_shortcut.page = {
          id: data.page_id,
          name: data.page_name,
        };
      }
      this.mode_form = data ? 'update' : 'create';
      this.$refs.modalShorcut.show();
    },

    handleIconUpload(e) {
      this.handleFileUpload(e, ['image/png', 'image/jpeg', 'image/jpg'], 5).then((res) => {
        this.item_shortcut.icon_url = res;
      });
    },

    saveItemShortcut() {
      this.$v.item_shortcut.$touch();
      if (!this.$v.item_shortcut.$error) {
        if (this.mode_form === 'create') {
          this.data_shortcut.shortcut.push({
            icon: this.item_shortcut.icon_url,
            title: this.item_shortcut.title,
            application_id: this.item_shortcut.application.id,
            application_name: this.item_shortcut.application.name,
            page_id: this.item_shortcut.page.id,
            page_name: this.item_shortcut.page.name,
          });
        } else {
          const data = {
            icon: this.item_shortcut.icon_url,
            title: this.item_shortcut.title,
            application_id: this.item_shortcut.application.id,
            application_name: this.item_shortcut.application.name,
            page_id: this.item_shortcut.page.id,
            page_name: this.item_shortcut.page.name,
          };
          this.data_shortcut.shortcut[this.index_selected] = data;
        }
        this.closeModalShortcut();
      }
    },

    removeItemShortcut() {
      this.data_shortcut.shortcut.splice(this.index_selected, 1);
      this.closeModalShortcut();
    },

    closeModalShortcut() {
      this.$refs.modalShorcut.hide();
      this.item_shortcut.icon_url = '';
      this.item_shortcut.title = '';
      this.item_shortcut.application = null;
      this.item_shortcut.page = null;
      setTimeout(() => {
        this.$v.item_shortcut.$reset();
      }, 1000);
    },

    saveShortcut() {
      this.$v.data_shortcut.$touch();
      if (!this.$v.data_shortcut.$error) {
        const dataParam = this.generateDataShortcut;
        if (!this.modeEdit) {
          this.saveWidget(dataParam);
        } else {
          const widgetId = this.dataEdit.id;
          this.updateWidget({ widgetId, dataParam });
        }
        this.closeShortcut();
      }
    },

    closeShortcut() {
      this.$emit('close-field');
      this.data_shortcut.title = '';
      this.data_shortcut.view_style = '';
      this.data_shortcut.shortcut = [];
      setTimeout(() => {
        this.$v.data_shortcut.$reset();
      }, 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/widget/widget-component/jShortcutPageSetup.vue